export const replaceWithHyphen = (string: string | null) => {
  if (typeof string === 'string') {
    return string.replace(/,+\s+|,+|\s+/g, '-');
  } else return string;
};
